import React, { useState, useEffect } from 'react';
import HomePage from './pages/HomePage';
import CameraPage from './pages/CameraPage';
import ViewerPage from './pages/ViewerPage';
import './App.css';

export default function App() {
  const [mode, setMode] = useState(null); // null | 'home' | 'camera' | 'viewer'

  useEffect(() => {
    // Check URL param for direct access
    const params = new URLSearchParams(window.location.search);
    const m = params.get('mode');
    if (m === 'camera' || m === 'viewer') setMode(m);
    else setMode('home');
  }, []);

  if (mode === 'camera') return <CameraPage onBack={() => setMode('home')} />;
  if (mode === 'viewer') return <ViewerPage onBack={() => setMode('home')} />;
  return <HomePage onSelect={setMode} />;
}
